import { styled } from '@mui/material/styles';
import { TextEllipsis } from '../text-ellipsis';

export const Wrapper = styled(TextEllipsis)``;
